var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletPicture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#02769D",
    strokeWidth: 2,
    fill: "#E7F3F9",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.5 12.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#02769D",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#02769D",
    cx: 8.75,
    cy: 8.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 21.25c.33-3.333 1.163-5 2.5-5 .985 0 3.522 1.023 5.609 2.144 3.526-1.269 4.937-5.297 6.218-5.796 1.748-.681 2.806 2.203 3.173 8.652H3.75z",
    fill: "#02769D"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletPicture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-picture.d1333ff2fc466fc7792018119d4c17ac.svg";